(function () {
  function normalize(value) {
    return String(value || '').toUpperCase().replace(/NINJA/g, '').replace(/[^A-Z0-9]/g, '');
  }

  function parseYears(value) {
    if (Array.isArray(value)) return value.map(Number).filter(Boolean).sort(function (a, b) { return a - b; });
    var text = String(value || '');
    var years = [];
    var range = text.match(/((?:19|20)\d{2})\s*(?:-|–|TO)\s*((?:19|20)\d{2})/i);
    if (range) {
      for (var year = Number(range[1]); year <= Number(range[2]); year += 1) years.push(year);
    }
    (text.match(/(?:19|20)\d{2}/g) || []).forEach(function (year) {
      if (years.indexOf(Number(year)) === -1) years.push(Number(year));
    });
    return years.sort(function (a, b) { return a - b; });
  }

  function parseModels(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    return String(value || '').split(/\s*(?:\|\||\|)\s*/).map(function (model) { return model.trim(); }).filter(Boolean);
  }

  function modelMatches(inputModel, generationModel) {
    var input = normalize(inputModel);
    var generation = normalize(generationModel);
    if (!input || !generation) return false;
    if (input === generation || input.indexOf(generation) !== -1 || generation.indexOf(input) !== -1) return true;
    return input.replace(/636$/, '') === generation.replace(/636$/, '');
  }

  function findGeneration(input) {
    var groups = window.NTFitmentGenerations || [];
    var brand = normalize(input.brand);
    var models = parseModels(input.models);
    var years = parseYears(input.years);
    var sku = normalize(input.sku);
    var code = normalize(input.code);
    var candidates = groups.map(function (group) {
      var score = 0;
      var groupCode = normalize(group.code);
      if (brand && normalize(group.brand) === brand) score += 40;
      else if (brand) return { group: group, score: -1 };
      if ((code && code === groupCode) || (sku && groupCode.length >= 2 && sku.indexOf(groupCode) !== -1)) score += 120;
      if (models.some(function (model) { return group.models.some(function (candidate) { return modelMatches(model, candidate); }); })) score += 60;
      var overlap = years.filter(function (year) { return group.years.indexOf(year) !== -1; }).length;
      score += Math.min(overlap, 5) * 8;
      if (years.length && overlap === years.length && overlap === group.years.length) score += 30;
      return { group: group, score: score };
    }).filter(function (candidate) { return candidate.score >= 60; }).sort(function (a, b) { return b.score - a.score; });

    if (!candidates.length) return null;
    if (candidates.length > 1 && candidates[0].score === candidates[1].score && candidates[0].score < 120) return null;
    return candidates[0].group;
  }

  function adjacentText(group) {
    var adjacent = [].concat(group.previous || [], group.next || []);
    if (!adjacent.length) return '';
    return 'Do not order this kit for ' + adjacent.map(function (item) {
      return item.models.join(' / ') + ' ' + item.years;
    }).join(' or ') + '. Those are different fairing generations and are not interchangeable.';
  }

  function render(root, input) {
    if (!root) return null;
    var group = findGeneration(input || {});
    var status = root.querySelector('[data-nt-fitment-guide-status]');
    var title = root.querySelector('[data-nt-fitment-guide-title]');
    var code = root.querySelector('[data-nt-fitment-guide-code]');
    var models = root.querySelector('[data-nt-fitment-guide-models]');
    var years = root.querySelector('[data-nt-fitment-guide-years]');
    var warning = root.querySelector('[data-nt-fitment-guide-warning]');
    var warningText = root.querySelector('[data-nt-fitment-guide-warning-text]');
    var table = root.querySelector('[data-nt-fitment-guide-table]');

    root.hidden = false;
    if (!group) {
      root.dataset.ntFitmentMatched = 'false';
      if (status) status.textContent = 'FITMENT CHECK REQUIRED';
      if (title) title.textContent = 'Confirm this product with a fitment specialist';
      if (code) code.textContent = '';
      if (table) table.hidden = true;
      if (warning) warning.hidden = false;
      if (warningText) warningText.textContent = 'We could not match this listing to a verified generation record. Contact us before ordering; compatibility has not been guessed.';
      return null;
    }

    root.dataset.ntFitmentMatched = 'true';
    root.dataset.ntFitmentCode = group.code;
    if (status) status.textContent = 'VERIFIED GENERATION';
    if (title) title.textContent = group.brand + ' ' + group.models.join(' / ') + ' ' + group.yearLabel;
    if (code) code.textContent = 'Generation ' + group.code;
    if (models) models.textContent = group.models.join(' / ');
    if (years) years.textContent = group.yearLabel;
    if (table) table.hidden = false;

    var messages = [adjacentText(group), group.specialNote].filter(Boolean);
    if (warning) warning.hidden = messages.length === 0;
    if (warningText) warningText.textContent = messages.join(' ');
    return group;
  }

  window.NTFitmentGuide = { find: findGeneration, render: render, parseYears: parseYears };
})();
